import Vue from 'vue'
import VueRouter from 'vue-router'

Vue.use(VueRouter)

const routes = [

  {

    path: '/HSC/home',
    name: 'home',
    component: () => import( /* webpackChunkName: "about" */ '../views/HSCS/Home.vue')
  },
  {
    // 造血干细胞简介
    path: '/zxgxb',
    name: 'home',
    component: () => import( /* webpackChunkName: "about" */ '../views/HSCS/Zxgxb.vue')
  },
  //倡议书

  {
    path: '/changyishu',
    name: 'home',
    component: () => import( /* webpackChunkName: "about" */ '../views/HSCS/changyishu.vue')
  },
  //报名条件

  {
    path: '/baomingtiaojian',
    name: 'home',
    component: () => import( /* webpackChunkName: "about" */ '../views/HSCS/baomingtiaojian.vue')
  },
  //报名流程

  {
    path: '/baomingliucheng',
    name: 'home',
    component: () => import( /* webpackChunkName: "about" */ '../views/HSCS/baomingliucheng.vue')
  },
  //捐献是否影响健康

  {
    path: '/jiankang',
    name: 'home',
    component: () => import( /* webpackChunkName: "about" */ '../views/HSCS/jiankang.vue')
  },
  //何时可以捐献

  {
    path: '/heshikyjx',
    name: 'home',
    component: () => import( /* webpackChunkName: "about" */ '../views/HSCS/heshikyjx.vue')
  },

  //采集过程

  {
    path: '/caijiguocheng',
    name: 'home',
    component: () => import( /* webpackChunkName: "about" */ '../views/HSCS/caijiguocheng.vue')
  },
  //报名点

  {
    path: '/baomingdian',
    name: 'home',
    component: () => import( /* webpackChunkName: "about" */ '../views/HSCS/baomingdian.vue')
  },
  //志愿者风采

  {
    path: '/zhiyuanzhefengcai',
    name: 'home',
    component: () => import( /* webpackChunkName: "about" */ '../views/HSCS/zhiyuanzhefengcai.vue')
  },
  //入库剪影

  {
    path: '/rukujianying',
    name: 'home',
    component: () => import( /* webpackChunkName: "about" */ '../views/HSCS/rukujianying.vue')
  },
  {
    path: '/jxxz',
    name: 'home',
    component: () => import( /* webpackChunkName: "about" */ '../views/HSCS/Jxxz.vue')
  },
  {
    path: '/HSC/apply',
    component: () => import( /* webpackChunkName: "about" */ '../views/HSCS/Apply.vue')
  },
  {
    path: '/HSC/applySucess',
    component: () => import( /* webpackChunkName: "about" */ '../views/HSCS/ApplySucess.vue')
  },
  {
    path: '/cjd',
    name: 'home',
    component: () => import( /* webpackChunkName: "about" */ '../views/HSCS/Cjd.vue')
  },
  {
    path: '/jxlc',
    name: 'home',
    component: () => import( /* webpackChunkName: "about" */ '../views/HSCS/Jxlc.vue')
  },
  // 遗体角膜捐献
  {
    path: '/cornea/home',
    name: 'home',
    component: () => import( /* webpackChunkName: "about" */ '../views/CornealDonation/CornealDonationHome.vue')
  },
  //器官捐献
  {
    path: '/DBCD/home',
    name: 'home',
    component: () => import( /* webpackChunkName: "about" */ '../views/DBCD/Home.vue')
  },
  {
    path: '/cornealDonation/apply',
    name: 'home',
    component: () => import( /* webpackChunkName: "about" */ '../views/CornealDonation/Apply.vue')
  },
  {
    path: '/cornealDonation/djjg',
    name: 'home',
    component: () => import( /* webpackChunkName: "about" */ '../views/CornealDonation/Djjg.vue')
  },
  {
    path: '/cornealDonation/djjg2',
    name: 'home',
    component: () => import( /* webpackChunkName: "about" */ '../views/CornealDonation/Djjg2.vue')
  },
  {
    path: '/cornealDonation/jnb',
    name: 'home',
    component: () => import( /* webpackChunkName: "about" */ '../views/CornealDonation/Jnb.vue')
  },
  {
    path: '/cornealDonation/applySucess',
    name: 'home',
    component: () => import( /* webpackChunkName: "about" */ '../views/CornealDonation/ApplySucess.vue')
  },
  {
    path: '/cornealDonation/checkin',
    name: 'home',
    component: () => import( /* webpackChunkName: "about" */ '../views/CornealDonation/CheckIn.vue')
  },

  // 捐款授权页面
  {
    path: '/contributeMoney/auth',
    name: 'home',
    component: () => import( /* webpackChunkName: "about" */ '../views/ContributeMoney/Auth.vue')
  },
  {
    path: '/contributeMoney/home',
    name: 'home',
    component: () => import( /* webpackChunkName: "about" */ '../views/ContributeMoney/Home.vue')
  },
  {
    path: '/contributeMoney/next',
    name: 'home',
    component: () => import( /* webpackChunkName: "about" */ '../views/ContributeMoney/Next.vue')
  },
  {
    path: '/contributeMoney/cert',
    name: 'home',
    component: () => import( /* webpackChunkName: "about" */ '../views/ContributeMoney/Cert.vue')
  },
  //志愿者服务
  {
    path: '/volunteer/home',
    name: 'home',
    component: () => import( /* webpackChunkName: "about" */ '../views/Volunteer/Home.vue')
  },

  //志愿者服务
  {
    path: '/volunteer/apply',
    name: 'home',
    component: () => import( /* webpackChunkName: "about" */ '../views/Volunteer/Apply.vue')
  },
  //AED
  {
    path: '/AED/home',
    name: 'home',
    component: () => import( /* webpackChunkName: "about" */ '../views/AED/Home.vue')
  },
  // 爱心讲坛
  {
    path: '/Rostrum/home',
    name: 'home',
    component: () => import( /* webpackChunkName: "about" */ '../views/Rostrum/Home.vue')
  },
  //掌上学
  {
    path: '/Study/home',
    name: 'home',
    component: () => import( /* webpackChunkName: "about" */ '../views/Study/Home.vue')
  },
  //政策法规
  {
    path: '/Rule/home',
    name: 'home',
    component: () => import( /* webpackChunkName: "about" */ '../views/Rule/Home.vue')
  }

]

const router = new VueRouter({
  mode: "history",
  routes
})

export default router